module.exports = __webpack_public_path__ + "static/img/14i.6c5887e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14i.jpg
// module id = pTfe
// module chunks = 0